/* Reuse the selected artwork for a lightweight format tour. Never select a variant or change a price. */
(function () {
  if (window.__pppFormatTour) return;
  window.__pppFormatTour = true;
  var motion = matchMedia('(prefers-reduced-motion: reduce)');
  var touch = matchMedia('(hover: none), (pointer: coarse)');
  var states = new Set(), registered = new WeakMap(), active = null, mobileTarget = null;
  var names = ['A4 print', 'A3 print', 'A4 framed – black', 'A4 framed – white', 'A4 framed – oak-effect', 'Canvas 8×10 in', 'Canvas 12×16 in', 'Digital download'];
  var collectionTimer, scrollFrame;

  function mediaFor(state) {
    if (state.main) {
      return state.el.dataset.pppView === 'format'
        ? state.el.querySelector('.ppp-fp--gallery .ppp-fp__stage')
        : state.el.querySelector('slideshow-container');
    }
    return state.el.querySelector('.ppp-style-card__img, .ppp-multi__image, .card-gallery') || state.el;
  }
  function sourceFor(state) {
    if (state.main) {
      var box = state.el.closest('.shopify-section').querySelector('[data-ppp-format-preview]');
      var bg = box && box.querySelector('[data-ppp-fp-art]').style.backgroundImage;
      return bg ? bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '') : '';
    }
    var img = state.el.querySelector('slideshow-slide[aria-hidden="false"] img') || state.el.querySelector('img');
    return img && (img.currentSrc || img.src) || '';
  }
  function bounds(state) {
    var media = mediaFor(state);
    return media && media.getBoundingClientRect();
  }
  function place(state) {
    var r = bounds(state), p = state.parent.getBoundingClientRect();
    if (!r || r.width < 60 || r.height < 60) return false;
    var x = r.left - p.left + state.parent.scrollLeft, y = r.top - p.top + state.parent.scrollTop;
    state.overlay.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + r.width + 'px;height:' + r.height + 'px;';
    state.controls.style.left = (x + 10) + 'px';
    state.controls.style.top = (y + 10) + 'px';
    return true;
  }
  function labelControls(state) {
    state.play.textContent = state.running ? 'Pause' : 'Play';
    state.play.setAttribute('aria-label', (state.running ? 'Pause' : 'Play') + ' format slideshow');
  }
  function show(state, index) {
    var api = window.PPPFormatPreview;
    if (!api || !place(state)) return false;
    var name = names[index % names.length];
    var spec = api.formats.find(function (f) { return f.test.test(name); });
    var src = sourceFor(state);
    if (!spec || !src) return false;
    state.index = index % names.length;
    var r = bounds(state), mm = Math.max(.08, Math.min((r.width - 54) / 335, (r.height - 108) / 420, 1.1));
    state.stage.style.setProperty('--mm', mm + 'px');
    var obj = state.overlay.querySelector('[data-ppp-fp-obj]');
    obj.className = 'ppp-fp__obj ppp-fp__obj--' + spec.kind + (spec.colour ? ' ppp-fp__obj--' + spec.colour : '');
    obj.style.setProperty('--w', spec.w); obj.style.setProperty('--h', spec.h);
    state.overlay.querySelectorAll('[data-ppp-fp-art], [data-ppp-fp-side]').forEach(function (el) { el.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")'; });
    api.align(state.overlay, spec, src);
    state.caption.textContent = 'Format tour · ' + name + (state.main ? ' · preview only' : '');
    state.overlay.dataset.pppTourFormat = name;
    state.overlay.hidden = false;
    state.controls.classList.add('is-visible');
    state.el.classList.add('ppp-tour-showing');
    return true;
  }
  function stop(state, restore) {
    clearTimeout(state.timer); state.timer = null;
    state.running = false; labelControls(state);
    if (restore) {
      state.overlay.hidden = true;
      state.controls.classList.remove('is-visible');
      state.el.classList.remove('ppp-tour-showing');
    }
    if (active === state) active = null;
  }
  function tick(state) {
    state.timer = setTimeout(function () {
      if (!state.el.isConnected || document.hidden) { stop(state, true); return; }
      show(state, state.index + 1); tick(state);
    }, 2000);
  }
  function start(state, manual) {
    if (!manual && (motion.matches || state.paused || state.blocked || document.hidden)) return;
    if (active && active !== state) stop(active, true);
    clearTimeout(state.timer);
    if (!show(state, state.overlay.hidden ? 0 : state.index)) return;
    active = state; state.running = true; state.paused = false; labelControls(state); tick(state);
  }
  function arm(state) {
    if (motion.matches || state.paused || state.blocked || document.hidden || state.timer || state.running) return;
    state.timer = setTimeout(function () { state.timer = null; start(state, false); }, 2000);
  }
  function leave(state, event) {
    if (event && event.relatedTarget && (state.el.contains(event.relatedTarget) || state.controls.contains(event.relatedTarget))) return;
    state.hovered = false; state.blocked = false; stop(state, true);
  }
  function register(el) {
    if (registered.has(el) || !el.querySelector('img')) return;
    var main = el.tagName === 'MEDIA-GALLERY';
    if (main && !el.closest('.shopify-section')?.querySelector('[data-ppp-format-preview]')) return;
    var parent = main ? el : el.parentElement;
    parent.classList.add('ppp-tour-positioner');
    var state = {el:el, parent:parent, main:main, index:0, paused:false, running:false};
    var overlay = document.createElement('div');
    overlay.className = 'ppp ppp-tour-overlay'; overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<div class="ppp-fp__stage"><div class="ppp-fp__obj" data-ppp-fp-obj><div class="ppp-fp__frame"><div class="ppp-fp__art" data-ppp-fp-art></div></div><div class="ppp-fp__side" data-ppp-fp-side></div><div class="ppp-fp__phone-notch"></div></div></div><span class="ppp-tour-caption"></span>';
    var controls = document.createElement('div'); controls.className = 'ppp-tour-controls';
    controls.setAttribute('role', 'group'); controls.setAttribute('aria-label', 'Format slideshow controls');
    var play = document.createElement('button'); play.type = 'button';
    // Keep playback control available on keyboard focus without covering the artwork.
    controls.append(play); parent.append(overlay, controls);
    state.overlay = overlay; state.controls = controls; state.play = play;
    state.stage = overlay.querySelector('.ppp-fp__stage'); state.caption = overlay.querySelector('.ppp-tour-caption');
    play.addEventListener('click', function (event) {
      event.preventDefault(); event.stopPropagation();
      if (state.running) { state.paused = true; stop(state, false); }
      else { state.blocked = false; start(state, true); }
    });
    [el, controls].forEach(function (target) {
      target.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch' || touch.matches) return;
        if (!state.hovered) state.blocked = false;
        state.hovered = true; place(state); controls.classList.add('is-visible'); arm(state);
      });
      target.addEventListener('pointerleave', function (event) { if (!touch.matches) leave(state, event); });
    });
    el.addEventListener('focusin', function () { place(state); controls.classList.add('is-visible'); });
    controls.addEventListener('focusin', function () { place(state); controls.classList.add('is-visible'); });
    controls.addEventListener('keydown', function (e) { if (e.key === 'Escape') { state.paused = true; stop(state, true); } });
    labelControls(state); registered.set(el, state); states.add(state);
    if (observer) observer.observe(el);
  }
  function collect() {
    states.forEach(function (state) {
      if (!state.el.isConnected) { stop(state, true); observer?.unobserve(state.el); state.overlay.remove(); state.controls.remove(); states.delete(state); }
      else if (!state.overlay.isConnected) { state.parent.append(state.overlay, state.controls); }
    });
    document.querySelectorAll('a.ppp-style-card, a.ppp-shop-card, .ppp-multi__card, product-card, media-gallery').forEach(register);
    chooseMobile();
  }
  function chooseMobile() {
    if (!touch.matches || motion.matches || document.hidden) return;
    var winner = null, distance = Infinity;
    states.forEach(function (state) {
      var r = bounds(state); if (!r || r.width < 60 || r.height < 60) return;
      var visible = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 100));
      var horizontal = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
      var eligible = visible / r.height >= .55 && horizontal / r.width >= .8;
      if (!eligible) { if (state === active) stop(state, true); state.blocked = false; return; }
      var d = Math.abs((r.top + r.bottom) / 2 - innerHeight / 2);
      if (d < distance) { distance = d; winner = state; }
    });
    if (winner !== mobileTarget) {
      if (mobileTarget) stop(mobileTarget, true);
      mobileTarget = winner;
      if (winner) { place(winner); winner.controls.classList.add('is-visible'); arm(winner); }
    }
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(chooseMobile, {threshold:[0,.55,.8,1]}) : null;
  function onScroll() { if (!scrollFrame) scrollFrame = requestAnimationFrame(function () { scrollFrame = null; chooseMobile(); }); }
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', function () { states.forEach(function (s) { if (!s.overlay.hidden) show(s,s.index); else if(s.hovered)place(s); }); onScroll(); });
  document.addEventListener('visibilitychange', function () { states.forEach(function (s) { stop(s,true); }); mobileTarget = null; if(!document.hidden)chooseMobile(); });
  motion.addEventListener('change', function () { states.forEach(function (s) { stop(s,true); }); mobileTarget = null; chooseMobile(); });
  // An option change or gallery navigation restores the shopper's actual selected format.
  document.addEventListener('change', function (event) {
    if (!event.target.closest('.product-details, .easify-product-options')) return;
    states.forEach(function (s) { if(s.main) { s.blocked = true; stop(s,true); } });
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-ppp-gallery-preview], media-gallery slideshow-controls')) return;
    states.forEach(function (s) { if(s.main) { s.blocked = true; stop(s,true); } });
  });
  function init() {
    collect();
    new MutationObserver(function(records) {
      if(records.every(function(r) { return r.target.closest && r.target.closest('.ppp-tour-overlay,.ppp-tour-controls'); }))return;
      clearTimeout(collectionTimer); collectionTimer = setTimeout(collect,150);
    }).observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
  }
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
